import { render, staticRenderFns } from "./manageClients.vue?vue&type=template&id=8ba6ddb8&scoped=true&"
import script from "./manageClients.vue?vue&type=script&lang=js&"
export * from "./manageClients.vue?vue&type=script&lang=js&"
import style0 from "./manageClients.vue?vue&type=style&index=0&id=8ba6ddb8&scoped=true&lang=css&"
import style1 from "./manageClients.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba6ddb8",
  null
  
)

export default component.exports